
import { useOrigin } from '@/hooks/routes';
export function useMusicLocation(id?: string) {
  const pathname = id ? `/l/${id}` : '/'

  const [origin] = useOrigin()

  const href = `${origin}${pathname}`
  return {
    pathname,
    href,
  }
}
